// ad-placeholder — 广告招租占位组件。
// variant: 'icon'  → 方形图标坑位(对应 forum_list_icon 格子,.pen J2JB4h):
//                    灰底方框(aspect-square,圆角 14,内含 plus 图标) + 下方「广告招租」标签
//          'card'  → ~180×180 卡片占位(对应 forum_list_card 瀑布流坑):空图框 + 下方「广告招租」
//          'banner'→ 350×60 横幅占位(对应 article_banner;宽度自适应撑满):框内「广告招租」(无下方标签)
// 样式参考 dogdisk-user.pen:灰底 #EEF2EF 描边 #C9D3CC 文案灰 #8C9B8F。
import { Plus } from 'lucide-react'

export type AdPlaceholderVariant = 'icon' | 'card' | 'banner'

export function AdPlaceholder({ variant }: { variant: AdPlaceholderVariant }) {
  if (variant === 'banner') {
    return (
      <div
        className="flex w-full items-center justify-center rounded border text-[11px] text-[#8C9B8F]"
        style={{ height: 60, backgroundColor: '#EEF2EF', borderColor: '#C9D3CC' }}
      >
        广告招租
      </div>
    )
  }

  if (variant === 'card') {
    // 空图框(180×180) + 下方「广告招租」标语,与真实卡片广告同结构。
    return (
      <div className="overflow-hidden rounded-xl border" style={{ borderColor: '#C9D3CC' }}>
        <div style={{ width: 180, height: 180, backgroundColor: '#EEF2EF' }} />
        <p className="px-2 py-1.5 text-center text-[14px] leading-snug text-[#8C9B8F]">广告招租</p>
      </div>
    )
  }

  // icon:灰底方框(填满格子,圆角 14,plus 图标) + 下方「广告招租」标签。对应 .pen J2JB4h slot。
  return (
    <div className="flex w-full flex-col items-center gap-1.5">
      <div
        className="flex aspect-square w-full items-center justify-center rounded-[14px] border"
        style={{ backgroundColor: '#EEF2EF', borderColor: '#C9D3CC' }}
      >
        <Plus size={24} className="text-[#8C9B8F]" />
      </div>
      <span className="w-full truncate text-center text-[11px] font-medium text-[#8C9B8F]">广告招租</span>
    </div>
  )
}
